<div class="popup-container">
    <div class="col-12">
        <div class="col-md-12" style="text-align: center;padding: 8px 0 5px 0;border-radius: 10px;">
            <h5>Found Previous Data</h5>
        </div>
        <div class="col-md-12" style="margin: 15px 0 15px 0;">
            <span><b>GIVE NAME:</b> {{applicationData.first_name}}</span>
        </div>
        <div class="col-md-12" style="margin: 15px 0 15px 0;">
            <span><b>SURNAME:</b> {{applicationData.last_name}}</span>
        </div>
        <div class="col-md-12" style="margin: 15px 0 15px 0;">
            <span><b>DATE OF BIRTH:</b> {{applicationData.dob}}</span>
        </div>
        <div class="col-md-12" style="margin: 15px 0 15px 0;">
            <span><b>PASSPORT NUMBER:</b> {{applicationData.passport_number}}</span>
        </div>
        <div class=" row d-flex mt-5 justify-content-between">
            <div class="col-lg-5 col-md-5 col-sm-5 col-5 mx-2 justify-content-center row">
                <button class="btn btn-primary" id="closebutton" mat-dialog-close (click)="onContinue()">
                    <h6 class="">Continue</h6>
                </button>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-5 col-5 mx-2 justify-content-center row">
                <button class="btn btn-secondary" mat-dialog-close>
                    <h6 class="text-btn">Cancel</h6>
                </button>
            </div>
        </div>
    </div>

</div>